import React, { Component } from 'react'
import { Formik } from "formik"
import { Button, Row, Col } from 'react-bootstrap';
import classNames from "classnames";
import { emptySchema } from '../forms/schemas';

class Wizard extends Component {
    static Page = ({ children, title, subtitle, className, ...props }) => {
        const Children = () => React.cloneElement(children, props);
        
        return (
            <div className={classNames("wizard-page", className)}>
                <div className="wizard-page--header">
                    {title && 
                        <h2 className="wizard-page--title">{title}</h2>}
                    {subtitle &&
                        <p className="wizard-page--subtitle">{subtitle}</p>}
                </div>
                <div className="wizard-page--body">
                    <Children />
                </div>
            </div>
        )
    }

    constructor(props) {
        super(props);
        this.state = {
            page: 0,
            values: props.initialValues
        };
    }

    next = values =>
        this.setState(state => ({
            page: Math.min(state.page + 1, this.props.children.length - 1),
            values
        }));

    previous = () =>
        this.setState(state => ({
            page: Math.max(state.page - 1, 0)
        }));

    validate = values => {
        const activePage = React.Children.toArray(this.props.children)[
            this.state.page
        ];
        return activePage.props.validate ? activePage.props.validate(values) : {};
    };

    handleSubmit = (values, bag) => {
        const { children, onSubmit } = this.props;
        const { page } = this.state;
        const isLastPage = page === React.Children.count(children) - 1;
        
        if (isLastPage) {
            return onSubmit(values);
        } else {
            bag.validateForm().then(valid => {
                console.log(valid);
                
                this.next(values);
                bag.setSubmitting(false);
            })
        }
    };

    render() {
        const { children, className } = this.props;
        const { page, values } = this.state;
        const activePage = React.Children.toArray(children)[page];
        const isLastPage = page === React.Children.count(children) - 1;
        return (
            <Formik
                initialValues={values}
                enableReinitialize={false}
                validate={this.validate}
                validationSchema={activePage.props.schema}
                onSubmit={this.handleSubmit}
                validateOnChange
                validateOnMount
                render={({ values, handleSubmit, isSubmitting, ...props }) => {
                    return (
                        <form onSubmit={handleSubmit} className={classNames("formik wizard-form", className)}>
                            {activePage}
                            <div className="wizard-form--buttons">
                                <Row className="gutters-12 w-100">
                                    {page > 0 && 
                                        <Col>
                                            <Button variant="secondary" block className="lg" size="xl" type="button" onClick={this.previous}>Back</Button>
                                        </Col>}
                                    {!isLastPage ? 
                                        <Col>
                                            <Button variant="primary" block className="lg" size="xl" type="submit">Next</Button>
                                        </Col> : 
                                        <Col>
                                            <Button variant="primary" block className="lg" size="xl" type="submit" disabled={isSubmitting}>Submit</Button>
                                        </Col>}
                                </Row>
                            </div>
                        </form>
                    )
                }}
            />
        );
    }
}

export default Wizard